module.exports = __webpack_public_path__ + "img/warning.acf5bad6.gif";